import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type UserPreferenceState =
  | string
  | number
  | boolean
  | Record<string, unknown>
  | unknown[]
  | null
  | undefined;

/**
 * UserPreferencesStateService
 * --------------------------------------------------------------------
 * User-facing preferences streams:
 *  - featurePage / uncheckValue / setToDefault / setValidation
 *  - columnSelection / filterOnChecked
 */
@Injectable({ providedIn: "root" })
export class UserPreferencesStateService {
  readonly featurePage = new BehaviorSubject<UserPreferenceState>("");
  readonly getFeaturePage: Observable<UserPreferenceState> = this.featurePage.asObservable();
  readonly uncheckValue = new BehaviorSubject<UserPreferenceState>("");
  readonly getuncheckValue: Observable<UserPreferenceState> = this.uncheckValue.asObservable();
  readonly setToDefault = new BehaviorSubject<UserPreferenceState>("");
  readonly getDefaultFilter: Observable<UserPreferenceState> = this.setToDefault.asObservable();
  readonly setValidation = new BehaviorSubject<UserPreferenceState>("");
  readonly getValidation: Observable<UserPreferenceState> = this.setValidation.asObservable();
  readonly columnSelection = new BehaviorSubject<UserPreferenceState>("");
  readonly getColumnSelection: Observable<UserPreferenceState> = this.columnSelection.asObservable();
  readonly filterOnChecked = new BehaviorSubject<UserPreferenceState>("");
  readonly filterRemove: Observable<UserPreferenceState> = this.filterOnChecked.asObservable();

  sendFeaturePage(data: UserPreferenceState): void {
    this.featurePage.next(data);
  }
  sendUncheckSort(data: UserPreferenceState): void {
    this.uncheckValue.next(data);
  }
  setFilter(data: UserPreferenceState): void {
    this.setToDefault.next(data);
  }
  sendValidationMessage(data: UserPreferenceState): void {
    this.setValidation.next(data);
  }
  setColumn(data: UserPreferenceState): void {
    this.columnSelection.next(data);
  }
  setFilterOnChecked(data: UserPreferenceState): void {
    this.filterOnChecked.next(data);
  }
}
